<template>
    <div class="row">
        <div class="col-md-12">
            <template v-if="paginatedData">
                <div class="table-responsive" >
                    <table class="table" >
                        <thead>
                        <tr>
                            <th>Дата</th>
                            <th>Тип</th>
                            <th>Цена</th>
                            <th>Чек</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="transaction in paginatedData">
                            <td>{{ moment(transaction.created_at).format('DD.MM.YYYY') }}</td>
                            <td class="type">
                                <span
                                    :class="{sale : transaction.type === 'TYPE_DONATION' || transaction.type === 'TYPE_GOT_FUNDS' || transaction.type === 'TYPE_GOT_OWNED_FUNDS', purchase: (transaction.type === 'TYPE_SPENT' || transaction.type === 'TYPE_SPENT_TRANSFERRED')}">
                                    {{ transaction.type === 'TYPE_DONATION' || transaction.type === 'TYPE_GOT_FUNDS' || transaction.type === 'TYPE_GOT_OWNED_FUNDS' ? 'Приход' : 'Расход' }}
                                </span>
                            </td>
                            <td>{{ transaction.type === 'TYPE_DONATION' || transaction.type === 'TYPE_GOT_FUNDS' || transaction.type === 'TYPE_GOT_OWNED_FUNDS' ? transaction.credit : transaction.debit }}  BYN</td>
                            <td class="action">
                                <a :href="`/storage${file.path}`"
                                   :data-lightbox="'transaction-' + transaction.id"
                                   v-for="(file, index) in transaction.images" v-show="index === 0" >Чеки</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="pagination-area" v-if="pageCount > 1">
                        <button
                            class="pagination-area__btn"
                            :disabled="pageNumber === 0"
                            @click="prevPage">
                            <span class="lnr lnr-arrow-left"></span>
                        </button>
                        <button
                            class="pagination-area__btn"
                            :disabled="pageNumber >= pageCount -1"
                            @click="nextPage">
                            <span class="lnr lnr-arrow-right"></span>
                        </button>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="tab-empty d-flex">Никаких поступлений или расходов еще не было</div>
            </template>

        </div>
    </div>
</template>

<script>

export default {
    name: "PetAndProjectTransactionsTabComponent",
    data() {
        return {
            moment: window.moment,
            options : {
                closeText : 'X'
            },
            pageNumber: 0,
            size: 5,
        };
    },
    props: ['object', 'type'],
    mounted() {
    },
    computed:{
        pageCount(){
            if(!this.object.transactions || !this.object.transactions.length) return false
            let l = this.object.transactions.length,
                s = this.size;
            return Math.ceil(l/s);
        },
        paginatedData(){
            if(!this.object.transactions || !this.object.transactions.length) return false
            const start = this.pageNumber * this.size,
                end = start + this.size;
            return this.object.transactions
                .slice(start, end);
        }
    },
    methods: {

        nextPage(){
            this.pageNumber++;
        },
        prevPage(){
            this.pageNumber--;
        },
    },
}
</script>

<style lang="scss" scoped>

.tab-empty{
    justify-content: center;
    align-items: center;
    height: 200px;
    padding: 10px;
    text-align: center;
}


.pagination-area{
    padding: 15px 0;
}
.pagination-area__btn{
    background: #ececec;
    border: none;
    line-height: 30px;
    width: 30px;
    height: 30px;
    box-shadow: none;
    border-radius: 50%;
    text-align: center;
    margin: 0 5px;
}

.pagination-area__btn span{
    vertical-align: middle;
}

@media screen and (max-width: 500px){
    .table tbody > tr > td{
        padding: 15px 10px;
    }
    .table thead > tr > th{
        padding: 15px 10px;
    }
}
</style>
